import { render, staticRenderFns } from "./SummaryInfoModal.vue?vue&type=template&id=83b4caa8&scoped=true"
import script from "./SummaryInfoModal.vue?vue&type=script&lang=js"
export * from "./SummaryInfoModal.vue?vue&type=script&lang=js"
import style0 from "./SummaryInfoModal.vue?vue&type=style&index=0&id=83b4caa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b4caa8",
  null
  
)

export default component.exports